import { AGENT_PROCEDURES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/agent_procedures_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

// One draft per Agent Operating Procedure, keyed in `records` by the procedure
// id, so the builder reads it with `getEntityById(procedureId, state.agent_procedures)`.
const initialState: any = standardInitialStateGenerator([]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
